<template>
  <div class="modal is-active" @keydown.esc="close()" tabindex="0">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title" v-if="users.length > 1">Bulk Email</p>
        <p v-if="users.length === 1" class="modal-card-title">Email for {{ users[0].fullName }}</p>
      </header>

      <section class="modal-card-body">
        <div v-if="!loading">
          <div v-if="step === 1" class="content">
            <div class="checkbox-row" v-for="template in templates" :key="template.id">
              <input type="radio" class="radio" :value="template" v-model="selectedTemplate" />
              <p style="marginLeft: 1rem;">{{ template.subject }}</p>
            </div>
          </div>
          <div v-if="step === 2" class="content">
            <p class="is-italic">You are viewing a preview for user: {{ users[0].fullName }}</p>
            <div v-html="preview"></div>
          </div>
          <div v-if="step === 3" class="content">
            <p class="is-italic">
              Please review the list of evaluators that will be emailed. Hit 'Submit' at the bottom
              to send the emails.
            </p>
            <table class="table is-fullwidth" style="marginTop: 1rem;">
              <thead>
                <tr>
                  <th>Send Bulk Email</th>
                  <th>Name</th>
                  <th>Email Already Sent?</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="evaluator in evaluators" :key="evaluator.id">
                  <td>
                    <input
                      type="checkbox"
                      class="checkbox"
                      :value="evaluator"
                      :checked="selectedEvaluators.map(e => e.id).indexOf(evaluator.id) > -1"
                      v-model="selectedEvaluators"
                    />
                  </td>
                  <td>
                    <router-link
                      :to="{ name: 'EvaluatorDetail', params: { evaluatorId: evaluator.id } }"
                    >
                      {{ evaluator.fullName }}
                    </router-link>
                  </td>
                  <td>
                    <i
                      class="fa fa-check"
                      v-if="
                        evaluator.emailRecords.filter(
                          record => record.template === selectedTemplate.id,
                        ).length
                      "
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="step === 4" class="content">
            <p class="is-italic">You are sending a duplicate email to a user are you sure you want to?</p>
          </div>
        </div>
        <LoadingBox v-if="loading" />
      </section>
      <footer class="modal-card-foot">
        <button class="button" @click="close()">Cancel</button>
        <button class="button" @click="previous()" v-if="step !== 1">Previous</button>
        <button v-if="step < 3" class="button is-primary" :disabled="disabled" @click="next()">
          Next
        </button>
        <button v-if="step === 3" class="button is-primary" @click="checkIfSentAlready()">Submit</button>
        <button v-if="step === 4" class="button is-primary" @click="sendEmails()">I'm Fine. Send it</button>
        <p class="is-italic" style="marginLeft: 1rem;" v-if="step === 1">
          A preview of the email will be shown on the next screen
        </p>
        <p class="has-text-danger" v-if="invalidEvaluators.length && step === 3">
          WARNING: You have selected evaluators that have already been sent this email. Please
          confirm this is intended before proceeding.
        </p>
      </footer>
    </div>
  </div>
</template>

<script>
import User from '@/services/users'
import EmailTemplate from '@/services/email-templates'

import LoadingBox from '@/components/LoadingBox'

export default {
  name: 'BulkEmailModal',
  components: {
    LoadingBox,
  },
  props: {
    users: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      templates: [],
      evaluators: [],
      selectedEvaluators: [],
      selectedTemplate: null,
      preview: null,
      step: 1,
      loading: false,
    }
  },
  computed: {
    disabled() {
      return this.selectedTemplate ? false : true
    },
    invalidEvaluators() {
      // Return all evaluators who already have a record of the currently selected EmailTemplate being sent to them.
      return this.selectedEvaluators.filter(
        evaluator =>
          evaluator.emailRecords.filter(record => record.template === this.selectedTemplate.id)
            .length,
      )
    },
  },
  watch: {
    // When the user selects a template, auto-select all evaluators who have not been sent an email from that template.
    selectedTemplate(template) {
      this.selectedEvaluators = this.evaluators.filter(
        evaluator => !evaluator.emailRecords.filter(record => record.template === template.id).length,
      )
    },
    // We need to ensure that the users include their email records. Whenever the users change, fetch these if necessary
    users: {
      async handler() {
        const result = await Promise.all(
          this.users.map(async user => {
            if (user.emailRecords === undefined) {
              user = await User.api.get(user.id)
            }
            return user
          }),
        )
        this.evaluators = result
      },
      immediate: true, // compute this initially as well as whenever it changes
    },
  },
  async created() {
    await this.fetchTemplates()
  },
  methods: {
    async fetchTemplates() {
      try {
        const response = await EmailTemplate.api.list()
        this.templates = response.results
      } catch (err) {
        this.$Alert.alert({
          type: 'error',
          message: `<p>Error Retrieving Email Templates</p>`,
          timeout: 6000,
        })
      }
    },
    async getEmailPreview() {
      const template = this.selectedTemplate
      const user = this.users[0]

      const response = await EmailTemplate.api.preview(template.id, user.id)
      this.preview = response
    },
    next() {
      this.step = this.step + 1
      if (this.step === 2) {
        this.getEmailPreview()
      }
      return
    },
    previous() {
      this.step = this.step - 1
    },
    close() {
      this.$emit('close')
    },
    invalidEvaluators2() {
      // Return all evaluators who already have a record of the currently selected EmailTemplate being sent to them.
      return this.selectedEvaluators.filter(
        evaluator =>
          evaluator.emailRecords.filter(record => record.template === this.selectedTemplate.id)
            .length,
      )
    },
    checkIfSentAlready(){
      var blah = this.invalidEvaluators2();
      console.log("blah");
      console.log(blah);
      console.log("selectedEvaluators");
      console.log(this.selectedEvaluators);
      console.log("this.selectedTemplate.id");
      console.log(this.selectedTemplate.id);
      if (blah.length>0)
      {
        console.log("we got a duplicate")
        this.step = this.step + 1
      }else{
        console.log("no duplicate")
        this.sendEmails();
      }
    },
    async sendEmails() {
      console.log("sendEmails")
      this.loading = true
      try {
        const response = await EmailTemplate.api.bulkEmailTemplate(
          this.selectedTemplate.id,
          this.selectedEvaluators.map(e => e.id),
        )
        //console.log(response)
        this.$Alert.alert({
          type: 'info',
          message: `<p>${this.selectedEvaluators.length} Evaluators Emailed Template: ${
            this.selectedTemplate.name
          }</p>`,
          timeout: 6000,
        })
        this.$emit('submit')
      } catch (err) {
        const error = err.response.data['detail']
        this.$Alert.alert({
          type: 'error',
          message: `<p>Error Sending Emails: ${error}</p>`,
          timeout: 6000,
        })
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-card {
  width: 65vw;
}
.checkbox-row {
  display: flex;
  margin-bottom: 0.5rem;
}
</style>
